import QRCode from 'qrcode'

/** PNG data URL (e.g. for `<img src>`) generated locally — no third-party HTTP API. */
export async function getQrCodeDataUrl(
  data: string,
  sizePx = 220
): Promise<string> {
  if (!data) return ''
  return QRCode.toDataURL(data, {
    width: sizePx,
    margin: 2,
    errorCorrectionLevel: 'M',
    type: 'image/png'
  })
}
